/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-param-reassign */
/* istanbul ignore file */
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import TreeMenu, { TreeMenuItem } from 'react-simple-tree-menu';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Box, Flex, Spacer, Spinner } from '@chakra-ui/core';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import isNumber from 'lodash/isNumber';
import isDate from 'lodash/isDate';
import isEmpty from 'lodash/isEmpty';
import { useParams } from 'react-router';
import { useStoreActions, useStoreState } from '../../../../models/hooks';
import { CandidateItemNode, NodeType, ParentItemNode } from './treeGroup';
import { Business } from '../../../administration/positionManagement/BusinessType';
import { useMessagingViewContext } from '../../MessagingViewContext';
import { EngagedCandidate } from '../../../../firebase/firestore/documents/candidate';
import { MESSAGING_TABS_NEW, POSITION_CANDIDATE_TABS } from '../../../../routes/constants';
import { SeekerContainerTabItems } from '../../seeker/SeekerContainerContext';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import SeekerListSortType from '../filters/seekerListSortType';
import NewCandidateItem from './candidateItem/NewCandidateItem';
import { Position } from '../../../../firebase/firestore/documents/position';
import { CandidateSearchResponse } from '../../../../controllers/candidateController';
import { SeekersPresenter } from './seekersPresenter';
import { RemoteConfigKey } from '../../../../firebase/remoteConfig';
import { getLatestDateForSorting, isPositionCandidatesPage } from '../../../../utils/candidatesUtils';

type Props = Record<string, unknown>;

const addBoxClass = (item: TreeMenuItem) => {
  switch (item.type) {
    case NodeType.PARENT:
      return 'parent-block';
    case NodeType.CHILD:
      return 'child-block';
    default:
      return 'candidate-block';
  }
};

type ToggleIconProp = {
  on: boolean;
};

const ToggleIcon = ({ on }: ToggleIconProp) => (
  <span>{on ? <ChevronUpIcon w={6} h={6} /> : <ChevronDownIcon w={6} h={6} />}</span>
);

const Loading = () => (
  <span>
    <Spinner size="sm" />
  </span>
);

const PAGE_LIMIT = 200;

const BusinessCandidateList: React.FC = () => {
  const {
    setSelectedEngagedCandidate,
    setSelectedEngagedSeeker,
    setSelectedCandidateId,
    selectedCandidateId,
  } = useMessagingViewContext();
  const { positionId } = useParams<{ positionId: string }>();

  const userData = useStoreState((s) => s.app.user);

  const getBusinessWithPositionAndCandidate = useStoreActions((a) => a.businessManagement.getBusinessWithPositionAndCandidate);
  const paginatedBusinesses = useStoreState((state) => state.businessManagement.paginatedBusinesses);
  const getPositionsWithCandidates = useStoreActions((actions) => actions.positionManagement.getPositionsWithCandidates);
  const allSeekerList: SeekersPresenter | undefined = useStoreState((s) => s.candidate.allCandidates);

  const isShowFavoriteStatusEnabled: boolean = useStoreState((state) => {
    return state.remoteConfig[RemoteConfigKey.SHOW_FAVORITE_STATUS];
  });

  const scrollableDivRef = React.useRef<HTMLDivElement>(null);

  const businesses = paginatedBusinesses.data;

  const { searchQuery, businessNameQuery, sort, searchAndSortTypes, listType } = useSeekersFilters();

  const [businessPresenter, setBusinessPresenter] = useState<{
    [key: string]: Business & {
      key: string;
      label: string;
      type: NodeType;
      nodes?: Partial<ParentItemNode>[];
    };
  }>({});

  const recruiterEngagements = useMemo(() => {
    const engagements: string[] = [];

    if (userData?.assignedPositionCount && userData?.assignedPositionCount > 0) {
      engagements.push('followed');
    }

    if (userData?.watchedPositionCount && userData?.watchedPositionCount > 0) {
      engagements.push('watched');
    }

    return engagements.length ? engagements : ['followed']; // default
  }, [userData]);

  useEffect(() => {
    let paginatedBusinessLength = 0;
    const firstPage = 0;
    const getBusinesses = (prevPage?: number) => {
      const payload: any = {
        limit: PAGE_LIMIT,
        page: (isNumber(prevPage) ? prevPage : paginatedBusinesses.page) + 1,
        // onlyFollowedBusiness: true,
        recruiterEngagements,
        sortBy: sort === SeekerListSortType.ALPHABETICAL ? 'name' : 'createdAt',
        sortOrder: 'asc',
        listType,
        advancedFilters: searchAndSortTypes,
      };
      if (!isEmpty(businessNameQuery)) {
        payload.businessNameQuery = businessNameQuery;
      } else {
        payload.searchQuery = searchQuery || '';
      }
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getBusinessWithPositionAndCandidate({
        params: payload,
      }).then((data) => {
        paginatedBusinessLength += data.data.length;
        const hasNext = data.page * PAGE_LIMIT < data.total;
        if (hasNext && paginatedBusinessLength < 16) {
          getBusinesses(data.page);
        }
      });
    };
    getBusinesses(firstPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, businessNameQuery, sort, searchAndSortTypes, listType]);

  useEffect(() => {
    const businessPresenterToSet: {
      [key: string]: Business & {
        key: string;
        label: string;
        type: NodeType;
        nodes?: Partial<ParentItemNode>[];
      };
    } = {};
    businesses.forEach((business: Business) => {
      const businessData = {
        ...business,
        key: business.id,
        label: business.name,
        type: NodeType.PARENT,
        isFetching: false,
        nodes: [
          {
            key: Math.random(),
            label: '',
          },
        ],
      };
      businessPresenterToSet[business.id] = businessData;
    });
    setBusinessPresenter(businessPresenterToSet);
  }, [businesses]);

  const selectedCallback = useCallback(
    (candidate?: Readonly<EngagedCandidate>) => {
      const redirectionFunction = isPositionCandidatesPage() ? POSITION_CANDIDATE_TABS : MESSAGING_TABS_NEW;
      if (candidate) {
        setSelectedCandidateId(candidate.id);
        setSelectedEngagedSeeker(candidate && { seekerId: candidate.seeker, candidateId: candidate.id });
        window.history.pushState(
          null,
          '',
          redirectionFunction(isPositionCandidatesPage() ? positionId : candidate.id, SeekerContainerTabItems.Messaging),
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSelectedEngagedCandidate, setSelectedEngagedSeeker],
  );

  const getBusinesses = (prevPage?: number) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getBusinessWithPositionAndCandidate({
      params: {
        limit: PAGE_LIMIT,
        page: (prevPage || paginatedBusinesses.page) + 1,
        // onlyFollowedBusiness: true,
        recruiterEngagements,
        searchQuery: searchQuery || '',
        sortBy: sort === SeekerListSortType.ALPHABETICAL ? 'name' : 'createdAt',
        sortOrder: 'asc',
        listType,
        advancedFilters: searchAndSortTypes,
      },
    }).then((data) => {
      const hasNext = data.page * PAGE_LIMIT < data.total;
      if (hasNext && !data.data.length) {
        getBusinesses(data.page);
      }
    });
  };

  const treeBusiness = Object.values(businessPresenter);

  const hasNext = paginatedBusinesses.page * PAGE_LIMIT < paginatedBusinesses.total;
  const isInitialLoading = paginatedBusinesses.isFetching && paginatedBusinesses.page < 1 && treeBusiness.length === 0;

  // const maxHeightOfTheContainer = useMemo(() => {
  //   return scrollableDivRef.current?.offsetTop ? window.innerHeight - (scrollableDivRef.current?.offsetTop || 0) : 0;
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [scrollableDivRef.current?.offsetTop]);

  const isCandidateActive = useCallback(
    (item: TreeMenuItem) => {
      const parents = (item.parent as string).split('/');
      const parentPositionId = parents[parents.length - 1];
      const [, seekerId] = (item.candidate as CandidateSearchResponse['data'][0]).id.split('_');
      const selectedPositionId = selectedCandidateId?.split('_')[0];
      const selectedSeekerId = selectedCandidateId?.split('_')[1];

      return parentPositionId === selectedPositionId && selectedSeekerId === seekerId;
    },
    [selectedCandidateId],
  );

  // Resort candidate nodes inside each position when sort value changes
  useEffect(() => {
    setBusinessPresenter((prevPresenter) => {
      const updatedPresenter = { ...prevPresenter };
      Object.keys(updatedPresenter).forEach((businessId) => {
        const business = updatedPresenter[businessId];

        if (business.nodes) {
          business.nodes = business.nodes.map((position) => {
            if (position.nodes) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              position.nodes = [...position.nodes].sort((a, b) => {
                if (sort === SeekerListSortType.ALPHABETICAL) {
                  return (a.label || '').localeCompare(b.label || '');
                }
                const aMoment = getLatestDateForSorting(a.candidate);
                const bMoment = getLatestDateForSorting(b.candidate);
                const aDate = isDate(aMoment) ? aMoment : aMoment.toDate();
                const bDate = isDate(bMoment) ? bMoment : bMoment.toDate();

                return bDate.getTime() - aDate.getTime();
              });
            }
            return position;
          });
        }
      });
      return updatedPresenter;
    });
  }, [sort]);

  return (
    <div
      id="scrollableDiv"
      style={{
        height: `calc(100vh - 182px)`,
        overflow: 'auto',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
      }}
      ref={scrollableDivRef}
    >
      <InfiniteScroll
        dataLength={treeBusiness.length}
        next={getBusinesses}
        hasMore={hasNext}
        loader={
          <Box marginY="auto" width="100%" textAlign="center">
            <Spinner color="#1F3CBA" data-testid="Spinner" />
          </Box>
        }
        scrollableTarget="scrollableDiv"
        scrollThreshold={0.8}
      >
        {isInitialLoading ? (
          <Box marginY="auto" width="100%" textAlign="center">
            <Spinner color="#1F3CBA" data-testid="Spinner" />
          </Box>
        ) : (
          <TreeMenu
            data={treeBusiness as never}
            onClickItem={() => {}}
            debounceTime={5}
            resetOpenNodesOnDataUpdate
            disableKeyboard
            cacheSearch={false}
          >
            {({ items }) => {
              return (
                <AnimatePresence initial={false}>
                  {items &&
                    items.length &&
                    items.map((item) => {
                      return (
                        <motion.div
                          layout
                          key={item.key}
                          id={item.key}
                          initial={{ opacity: 1 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 1 }}
                          transition={{ duration: 0.2, ease: 'linear' }}
                        >
                          <Box className={addBoxClass(item)} data-testid="SeekerListItem">
                            <Box
                              data-testid="SeekerToggleIcon"
                              className="candidate-bar"
                              id="test"
                              onClick={(e) => {
                                item.toggleNode?.();
                                if (!item.isOpen && item.type === NodeType.PARENT) {
                                  setBusinessPresenter((prevValue) => ({
                                    ...prevValue,
                                    [item.key]: {
                                      ...prevValue[item.key],
                                      isFetching: true,
                                    },
                                  }));
                                  // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                  getPositionsWithCandidates({
                                    businessId: item.key,
                                    filters: {
                                      listType,
                                      searchQuery,
                                      sortBy: sort === SeekerListSortType.ALPHABETICAL ? 'name' : 'createdAt',
                                      sortOrder: 'asc',
                                      advancedFilters: searchAndSortTypes,
                                    },
                                  }).then((res) => {
                                    setBusinessPresenter((prevValue) => ({
                                      ...prevValue,
                                      [item.key]: {
                                        ...prevValue[item.key],
                                        isFetching: false,
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                                        nodes: res.data.map(
                                          (
                                            position: Position & { candidates: CandidateSearchResponse['data']; total: number },
                                          ) => ({
                                            key: position.id,
                                            label: position.customName,
                                            type: NodeType.CHILD,
                                            nodes: position.candidates
                                              .sort((a: any, b: any) => {
                                                if (sort === SeekerListSortType.ALPHABETICAL) {
                                                  return a.fullName.localeCompare(b.fullName);
                                                }

                                                const aMoment = getLatestDateForSorting(a.candidate);
                                                const bMoment = getLatestDateForSorting(b.candidate);
                                                const aDate = isDate(aMoment) ? aMoment : aMoment.toDate();
                                                const bDate = isDate(bMoment) ? bMoment : bMoment.toDate();

                                                return bDate.getTime() - aDate.getTime();
                                              })
                                              .map((candidate: CandidateSearchResponse['data'][0]) => ({
                                                key: candidate.id,
                                                label: candidate.fullName,
                                                type: NodeType.CANDIDATE,
                                                candidate,
                                              })),
                                          }),
                                        ),
                                      },
                                    }));
                                    e.stopPropagation();
                                  });
                                } else {
                                  e.stopPropagation();
                                }
                              }}
                            >
                              {item.isFetching ? (
                                <Loading />
                              ) : (
                                item.type !== NodeType.CANDIDATE && <ToggleIcon on={item.isOpen} />
                              )}
                              {item.type === NodeType.PARENT && (
                                <Flex fontWeight={700}>
                                  {item.label}
                                  <Spacer />
                                </Flex>
                              )}
                              {item.type === NodeType.CHILD && <Box>{item.label}</Box>}
                              {item.type === NodeType.CANDIDATE && (
                                <NewCandidateItem
                                  selectedCallback={selectedCallback}
                                  item={item as CandidateItemNode}
                                  isActive={isCandidateActive(item)}
                                  seekerList={allSeekerList}
                                  isShowFavoriteStatusEnabled={isShowFavoriteStatusEnabled}
                                />
                              )}
                            </Box>
                          </Box>
                        </motion.div>
                      );
                    })}
                </AnimatePresence>
              );
            }}
          </TreeMenu>
        )}
      </InfiniteScroll>
    </div>
  );
};

export default BusinessCandidateList;
